import { OWNER } from "../reducers/branchs";


export const ownerBranchs = (branchs: Array<any>) => ({
    type: OWNER.BRANCHS,
    payload: branchs
});

export const clearBranchs = () => ({
    type: OWNER.CLEAR
})